import { defaultLocale } from "@pkg/config/languages";
import groq from "groq";

export const translatedFieldQuery = (fieldName: string) => groq`
  "${fieldName}": coalesce(
    ${fieldName}[language == $locale][0].value,
    ${fieldName}[language == "${defaultLocale}"][0].value,
  )
`
